import _ from 'underscore';
import { get } from '@bingads-webui-universal/primitive-utilities';
import {
  ModelDefinition, ResourceIds, DataRecord, EntityOptions,
} from '../types';

function needCast(definition: ModelDefinition, options: EntityOptions): boolean {
  // _.has means has own, it will not check property in __proto__
  const jsdataResource = _.has(options, 'entitySet')
    ? get(options, 'entitySet.type.elementType.jsdataResource')
    : get(options, 'entitySet.jsdataResource');

  return !_.isEmpty(jsdataResource) && definition !== jsdataResource;
}

export function resIds({
  resIds: ids,
  definition,
  options,
}: {
  resIds: ResourceIds;
  definition: ModelDefinition;
  options: EntityOptions;
}): ResourceIds {
  return needCast(definition, options)
    ? ids.$cast(`Model.${definition.name}`)
    : ids;
}

export function data({
  data: d,
  definition,
  options,
}: {
  data: DataRecord;
  definition: ModelDefinition;
  options: EntityOptions;
}): DataRecord {
  const extra = needCast(definition, options)
    ? { '@odata.type': `Model.${definition.name}` }
    : {};

  return _.extend(extra, d);
}
